export const DeliveryType = {
    RECEBER_EM_CASA: "RECEBER_EM_CASA",
    RETIRAR_NA_LOJA: "RETIRAR_NA_LOJA"
};

export const DeliverySubtype = {
    EXPRESSA: "ENTREGA_EXPRESSA",
}
